import { isEmpty, isEqual, isObject, transform, values, xorWith } from 'lodash';

export function deepEqual(a, b) {
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for (var key in a) if (!deepEqual(a[key], b[key])) return false;
    return true;
  } else return a === b;
}

export const isEmptyObj = (obj) => !values(obj).some((x) => x !== undefined);
export const isEmptyArray = (arr) => !values(arr).some((x) => !isEmptyObj(x));
export const isDeepEmptyArray = (obj) =>
  !values(obj).some((x) => !isEmptyArray(x));

export function difference(object, base) {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base?.[key])) {
      result[key] =
        isObject(value) && isObject(base?.[key])
          ? difference(value, base?.[key])
          : value;
    }
  });
}

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));
